import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PACKAGE, PACKAGEALL } from "../../services/actions";
import { Box, Grid, Button, Paper, TextField, Pagination } from "@mui/material";
import { BsFilePlusFill } from "react-icons/bs";
import RDialog from "../extra/RDialog";
import Form from "./Form";
import ActionBar from "../extra/ActionBar";
import PackageCard from "../extra/PackageCard";

export default function View() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const ref2 = React.useRef();

  const packageallState = useSelector((state) => state?.packageallState);
  const packageState = useSelector((state) => state?.packageState);
  const user = useSelector((state) => state?.loginState?.auth);
  const isSuperUser = Boolean(user?.is_superuser || user?.main_role === "SuperAdmin");
  const canEditPackage = Boolean(isSuperUser || user?.permissions?.includes("package.change_package"));
  const canDeletePackage = Boolean(isSuperUser || user?.permissions?.includes("package.delete_package"));
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchPackages = (page = 0) => {
    const url = page === 0 ? `package/${page}/` : `package/?page=${page}`; // pass page number
    dispatch({ type: `${PACKAGEALL}_GET`, payload: url });
  };

  React.useEffect(() => {
    //dispatch({ type: `${PACKAGEALL}_GET`, payload: 0 });
    fetchPackages(0);
  }, []);

  React.useEffect(() => {
    fetchPackages(page);
  }, [page]);

  React.useEffect(() => {
    if (packageState?.success) {
      setOpen(false);
    }
    dispatch({ type: `${PACKAGEALL}_GET`, payload: 0 });
  }, [packageState.data]);

  return (
    <>
      <RDialog
        title={defV?.id ? "Edit Package" : "Add New Package"}
        open={open}
        handleClose={() => setOpen(false)}
      >
        <Form
          defaultValues={defV}
          onCancel={() => setOpen(false)}
          onSubmit={(data) => {
            const ACTION = data?.id ? `${PACKAGE}_PATCH` : `${PACKAGE}_POST`;
            dispatch({ type: ACTION, payload: data });
          }}
        />
      </RDialog>

      <Box sx={{ p: 2 }}>
        <ActionBar
          hasPermission={Boolean(isSuperUser || user?.permissions?.includes("package.add_package"))}
          label="Package"
          setOpen={() => {
            setDefV({});
            setOpen(true);
          }}
          btnLabel="Add Package"
        />

        <Box
          elevation={1}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            px: 2,
            py: 1,
            my: 2,
            borderRadius: 2,
          }}
        >
          <input
            inputRef={ref2}
            variant="outlined"
            size="small"
            placeholder="Search by title"
            fullWidth
          />
          <Button
            className="btn-primary"
            onClick={() => {
              dispatch({
                type: `${PACKAGEALL}_GET`,
                payload: `package/0/?filter_by={"title":"${ref2.current.value}"}`,
              });
            }}
          >
            Search
          </Button>
        </Box>

        <Grid container spacing={2}>
          {packageallState?.data?.results?.map((data, index) => {
            data.image = "http://plotdlive.bglivepro.com/jpg/image.jpg";
            data.no_users = data?.users?.length;

            return (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                <PackageCard
                  canEdit={canEditPackage}
                  canDelete={canDeletePackage}
                  keys={[
                    "amount",
                    "title",
                    "days",
                    "image_retention",
                    "video_retention",
                    "hybrid",
                    "hd_ptz",
                    "_4k_ptz",
                    "_24mp",
                    "_32mp",
                    "_50mp",
                    "_60mp",
                    "description",
                  ]}
                  data={data}
                  onClick={() => {
                    //navigate("/timelapse-preview/", {})
                  }}
                  onAction={(action, data) => {
                    if (action === "Edit") {
                      setDefV(data);
                      setOpen(true);
                    } else if (action === "Delete") {
                      dispatch({
                        type: `${PACKAGE}_DELETE`,
                        payload: data?.id,
                      });
                    }
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.ceil(packageallState?.data?.count / pageSize)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      </Box>
    </>
  );
}
